module.exports = __webpack_public_path__ + "media/ru_ru_s1_Artem.02e7ad31.mp3";